import * as React from 'react';

interface IFormRadioProps extends React.PropsWithChildren {
	onChange?: (e: React.FormEvent<HTMLInputElement>) => any;
	name: string;
	value: string;
	checked?: boolean;
	label?: string;
	alignment?: 'default' | 'horizontal' | 'vertical';
}

export const FormRadio: React.FC<IFormRadioProps> = ({ name, value, checked, label, alignment, onChange, children }) => {
	const id = `${name}-${value}`;
	const className = `radio radio--${checked ? 'checked' : 'unchecked'} radio--${name} radio--${id}`;

	const handler = onChange || ((e: React.FormEvent<HTMLInputElement>) => e.preventDefault());

	return <div className={`radio__wrapper radio__wrapper-${alignment || 'default'}`}>
		<label className={className} htmlFor={id}>
			<div className="radio__container">
				<input data-testid="radio-button" type="radio" className="radio__input" value={value} id={id} name={name} onChange={handler} checked={checked} />
				<div className="radio__button"></div>
				<div className="radio__label">{label || ''}</div>
			</div>
			<div className="radio__children">
				{children}
			</div>
		</label>
	</div>;
};
